import { useEffect } from "react";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from "react-i18next";
import { ChecklistType } from "../../../../service/Checklists";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { Slider, Stack, TextField } from "@mui/material";
import { useMask } from "@react-input/mask";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';


export default function RangeScoringTab({
  form,
  checked,
  setChecked,
  itemRange,
  setItemRange,
}: {
  form: ChecklistType,
  checked: boolean
  setChecked: Function,
  itemRange: any[],
  setItemRange: Function

}) {
  const { t } = useTranslation('translation');
  const inputRef = useMask({ mask: '___', replacement: { _: /\d/ } });

  useEffect(() => {
    if (form.range) {
      const objs: any = [];
      Object.keys(form.range).forEach((e: any, i) => {
        objs.push({
          index: i,
          name: form.range ? form.range[e] : '',
          range: Number(e)
        });
      });
      setItemRange(objs);
    }
  }, []);

  const marks = [
    { value: 0, label: 0 },
    { value: 5, label: '|' },
    { value: 10, label: 10 },
    { value: 15, label: '|' },
    { value: 20, label: 20 },
    { value: 25, label: '|' },
    { value: 30, label: 30 },
    { value: 35, label: '|' },
    { value: 40, label: 40 },
    { value: 45, label: '|' },
    { value: 50, label: 50 },
    { value: 55, label: '|' },
    { value: 60, label: 60 },
    { value: 65, label: '|' },
    { value: 70, label: 70 },
    { value: 75, label: '|' },
    { value: 80, label: 80 },
    { value: 85, label: '|' },
    { value: 90, label: 90 },
    { value: 95, label: '|' },
    { value: 100, label: 100 }
  ];

  const valueLabelFormat = (value: number) => {
    const title = itemRange.find((e) => e.range === value)?.name;
    if (!title) return <></>;
    return <span style={{ backgroundColor: '#3F51B5', color: 'white' }} className="tag">{title}</span>;
  };

  return (
    <Stack
      sx={{ width: '100%', padding: '20px' }}
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={5}
    >
      <label className="checkbox" style={{ alignItems: 'center' }}>
        <input
          onClick={() => trackEventMatomo('modal config form', 'click', 'input', 'seleciona valor')}
          checked={checked}
          onChange={() => setChecked(!checked)}
          type="checkbox"
        />&nbsp;
        {t('formDetails.range_scoring.Habilitar_range_Scoring')}
      </label>
      {checked &&
        <Stack
          width={'100%'}
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={5}
        >
          <Slider
            max={100}
            min={0}
            valueLabelFormat={valueLabelFormat}
            defaultValue={100}
            getAriaLabel={() => itemRange[0].name}
            valueLabelDisplay="on"
            value={itemRange.map((e) => e.range)}
            marks={marks}
          />
          <Stack
            width={'100%'}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            {itemRange.map((e, i) => (
              <Stack
                sx={{ width: '100%' }}
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0.5}
                key={i}
              >
                <TextField
                  size="small"
                  required
                  sx={{
                    '.MuiInputBase-input': {
                      padding: '10px 5px 10px 10px'
                    }
                  }}
                  fullWidth
                  label='Nome do range'
                  onClick={() => trackEventMatomo('modal config form', 'click', 'input', 'adiciona valor')}
                  type="text"
                  value={itemRange[i].name}
                  onChange={(e) => {
                    const newState = itemRange.map((item, index) => {
                      if (index === i) {
                        item.name = e.target.value;
                      }
                      return item;
                    });
                    setItemRange(newState);
                  }}
                />
                <TextField
                  size="small"
                  required
                  key={i}
                  sx={{
                    '.MuiInputBase-input': {
                      textAlign: 'center',
                    }
                  }}
                  color={`${itemRange?.some((ele) => ele.range > 100) ? 'error' : 'primary'}`}
                  inputRef={inputRef}
                  inputProps={{ max: marks[20].label, min: marks[0].label, maxLength: 3, type: 'numeric' }}
                  label='Valor do range'
                  onClick={() => trackEventMatomo('modal config form', 'click', 'input', 'adiciona valor')}
                  value={itemRange[i].range}
                  onChange={(e) => {
                    const newState = itemRange?.map((item, index) => {
                      if (index === i) {
                        item.range = Number(e.target.value);
                      }
                      return item;
                    });
                    setItemRange(newState);
                  }} />
                {i === 0 ?

                  <AddCircleIcon
                    fontSize="large"
                    color='success'
                    sx={{ ':hover': { cursor: 'pointer' } }}
                    onClick={() => {
                      trackEventMatomo('modal config form', 'click', 'button', 'aumenta valor');
                      setItemRange([...itemRange, { index: itemRange.length, name: t('formDetails.range_scoring.Novo_Range'), range: 50 }]);
                    }}
                  />
                  :
                  <RemoveCircleIcon
                    fontSize="large"
                    color='error'
                    sx={{ ':hover': { cursor: 'pointer' } }}
                    onClick={() => {
                      trackEventMatomo('modal config form', 'click', 'button', 'remove valor');
                      setItemRange(itemRange.filter((el) => el.index !== e.index));
                    }}
                  />
                }
              </Stack>
            ))}
          </Stack>
        </Stack>
      }
    </Stack>
  );
}